import { render } from "./LinkButton.vue?vue&type=template&id=9617f236"
import script from "./LinkButton.vue?vue&type=script&lang=js"
export * from "./LinkButton.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/ui-components/LinkButton.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "9617f236"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('9617f236', __exports__)) {
    api.reload('9617f236', __exports__)
  }
  
  module.hot.accept("./LinkButton.vue?vue&type=template&id=9617f236", () => {
    api.rerender('9617f236', render)
  })

}


export default __exports__